<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
      <font-awesome-icon class="ml-2" :icon="['fas', 'chevron-down']"/>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item @click="updateLocale('en')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;English</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('it')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/it.png" alt="it" /> &nbsp;Italian</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('es')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;Spanish</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  computed: {
    i18n_locale_img () {
      // Use below code to dynamically fetch image instead of if-else
      // NOTE: We used if-else because laravel throws error in 'yarn prod'.
      // If you are not using laravel + Vue, you can use below code to dynamically get image
      // return require(`@/assets/images/flags/${this.$i18n.locale}.png`)

      const locale = this.$i18n.locale
      if (locale === 'en')      return require('@/assets/images/flags/en.png')
      else if (locale === 'it') return require('@/assets/images/flags/it.png')
      else if (locale === 'es') return require('@/assets/images/flags/es.png')
      else return require('@/assets/images/flags/it.png')
    },
    getCurrentLocaleData () {
      const locale = this.$i18n.locale
      if (locale === 'en')      return { flag: 'en', lang: 'EN'    }
      else if (locale === 'it') return { flag: 'it', lang: 'IT' }
      else if (locale === 'es') return { flag: 'es', lang: 'ES'     }
    }
  },
  methods: {
    updateLocale (locale) {
      this.$i18n.locale = locale;
      this.$validator.locale = locale;
      this.$store.dispatch('updateUserInfo', { language: locale });
      window.location.reload();
    }
  }
}
</script>

<style lang="scss">
.i18n-dropdown {
  margin-left: -4px;
  margin-top: 15px;
}

.items-center.i18n-locale {
  span {
    color: #fff;
  }
}
</style>
